import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Link} from 'react-router-dom'
import {Grid, Button} from 'react-bootstrap'
import UserGroupsList from './usergroups-list'
import PageTitle from "../../../common/page-title/index";
import ArrowButton from "../../../common/button-arrow";
import {getUserGroups} from '../../../../actions/usergroups'

import './styles.css'

class UserGroups extends Component {
  constructor(props){
    super(props);
  }

  componentWillMount() {
    this.props.dispatch(getUserGroups());
  }

  render(){
    return (
      <Grid bsClass="container" fluid className="usergroups">
        <PageTitle>User groups</PageTitle>
        <Link to="/admin/user-groups/new">
          <ArrowButton color="red"
                       className="add-usergroup"
                       submit={false}
                       arrow={false}
                       permissions={{
                         action:       'create',
                         subjectClass: 'UserGroup'
                       }}>Add usergroup</ArrowButton>
        </Link>

        <UserGroupsList
          userGroups={this.props.userGroups}
          fetching={this.props.fetching}
          fetched={this.props.fetched}
        />
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    userGroups: state.userGroups.userGroups,
    fetched: state.userGroups.fetched,
    fetching: state.userGroups.fetching,
  };
};

export default connect(mapStateToProps)(UserGroups);


// WEBPACK FOOTER //
// ./src/components/admin/usergroups/list/index.jsx